var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import createElement from "../logical-components/createElement";
import buildInput from "../visual-components/input/field";
import buildSearch from "../visual-components/input/search";
import buildButton from "../visual-components/input/button";
import handleSearch from "../logical-components/handleSearch";
import renderText from "../logical-components/renderText";
import internalEvents from "../logical-components/internalEvents";
import "./scss/search.scss";
// Search elements in order
var searchElements = [
    {
        label: 'firstName',
        type: 'input',
    },
    {
        label: 'lastName',
        type: 'input',
    },
    {
        label: 'birthPlace',
        type: 'input',
    },
    {
        label: 'passingPlace',
        type: 'input',
    },
    {
        label: 'birthDate',
        type: 'date',
    },
    {
        label: 'passingDate',
        type: 'date',
    },
    {
        label: 'searchbutton',
        type: 'button',
    },
];
var simpleSearch = [
    {
        label: 'search',
        type: 'searchInput',
        defaultValue: null
    },
];
// Generate the wrapper elements
var buildWrapper = function () {
    var searchWrapper = createElement('div', [
        { type: 'class', value: '_mnslq-ss' },
    ]);
    var searchElement = createElement('div', [
        { type: 'class', value: '_mnslq-sselements' },
    ]);
    var searchText = createElement('div', [
        { type: 'class', value: '_mnslq-sstexts' },
    ]);
    return {
        searchWrapper: searchWrapper,
        searchElement: searchElement,
        searchText: searchText,
    };
};
var generateElements = function (searchElements, updateState, submitSearch, actions, section) {
    return searchElements.map(function (item) {
        var _a, _b, _c;
        if (item.type === 'input' || item.type === 'date') {
            return buildInput({
                name: item.label,
                label: ((_a = section.options) === null || _a === void 0 ? void 0 : _a.deceasedPlaceLabel) || renderText("search.".concat(item.label, ".label")),
                id: item.label,
                type: item.type,
                placeholder: renderText("search.".concat(item.label, ".placeholder")),
                onChange: function (e) {
                    updateState(item.label, e.target.value);
                },
                onFocus: function () {
                    actions.onFocus();
                },
                outFocus: function () {
                    actions.outFocus();
                },
                onEnter: function () {
                    actions.onEnter();
                },
            });
        }
        if (item.type === 'searchInput') {
            var placeholder = (_c = (_b = section.options) === null || _b === void 0 ? void 0 : _b.placeholder) !== null && _c !== void 0 ? _c : renderText("search.".concat(item.label, ".placeholder"));
            return buildSearch({
                label: renderText("search.".concat(item.label, ".label")),
                id: item.label,
                defaultValue: item.defaultValue,
                placeholder: placeholder,
                onChange: function (e) {
                    updateState(item.label, e.target.value);
                },
                onClick: function () {
                    submitSearch();
                },
                onClear: function () {
                    updateState('search', '');
                    submitSearch();
                },
                onFocus: function () {
                    actions.onFocus();
                },
                outFocus: function () {
                    actions.outFocus();
                },
                onEnter: function () {
                    actions.onEnter();
                },
            });
        }
        if (item.type === 'button') {
            return buildButton({
                label: renderText("search.".concat(item.label, ".label")),
                onClick: function () {
                    submitSearch();
                },
            });
        }
    });
};
// Search section
var search = function (_a) {
    var section = _a.section, config = _a.config;
    var events = internalEvents(config);
    // Search wrapper
    var _b = buildWrapper(), searchWrapper = _b.searchWrapper, searchElement = _b.searchElement, searchText = _b.searchText;
    // State management
    var state = {};
    var updateState = function (key, value) {
        // Reset state when simple search is being used
        if (key === 'search') {
            state = {};
        }
        else {
            delete state.search;
        }
        state[key] = value;
    };
    var submitSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handleSearch(state, config);
            return [2 /*return*/];
        });
    }); };
    var onEnter = function () {
        submitSearch();
    };
    var onFocus = function () { };
    var outFocus = function () { };
    // Text
    searchText.innerHTML = renderText('search.text');
    var renderSearchFields = function (layoutvariant) {
        var _a;
        if (layoutvariant === void 0) { layoutvariant = ''; }
        if (layoutvariant !== 'compact' && !((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.simplesearch)) {
            searchElement.innerHTML = '';
            var elements = generateElements(searchElements, updateState, submitSearch, { outFocus: outFocus, onFocus: onFocus, onEnter: onEnter }, section);
            elements.forEach(function (element) { return searchElement.appendChild(element); });
        }
        else {
            searchElement.innerHTML = '';
            // Add default value to search element when needed
            var urlParams = new URLSearchParams(window.location.search);
            var searchString = urlParams.get('search');
            if (searchString) {
                var firstSimpleSearch = simpleSearch[0];
                firstSimpleSearch.defaultValue = searchString;
            }
            var element = generateElements(simpleSearch, updateState, submitSearch, { outFocus: outFocus, onFocus: onFocus, onEnter: onEnter }, section)[0];
            element.classList.add('_mnslq-simplesearch');
            searchElement.appendChild(element);
        }
    };
    // Render initially
    var render = function () {
        // Render complex or simple search
        renderSearchFields(config.sizeVariant);
        config.searchSizeVariant = (config.sizeVariant === 'compact') ? 'simple' : 'complex';
        // render elements into the section for the first time
        searchWrapper.appendChild(searchElement);
        searchWrapper.appendChild(searchText);
    };
    render();
    // Handle resizing rerenders
    // When compact we do not ever show the complex search options
    var reRender = function (variant) {
        var _a;
        // Don't do anything if simpleSearch is always enabled
        if ((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.simplesearch) {
            return;
        }
        // Otherwise rerender
        var searchVariant = (variant === 'compact') ? 'simple' : 'complex';
        if (config.searchSizeVariant !== searchVariant) {
            renderSearchFields(variant);
            config.searchSizeVariant = searchVariant;
        }
    };
    events.on('resize', reRender);
    // Return view
    return searchWrapper;
};
export default search;
